export enum Roles {
    Admin = "Admin",
    Unauthorized = "Unauthorized",
    KrookieJournal = "Krookie journal",
    KrookieCreator = "Krookie creator",
    KrookieApprover = "Krookie approver",
    AttachmentManager = "Attachment manager",
    ReportsJournal = "Reports Journal",
    StudyCreator = "Study Creator",
    DepartmentSpecialist = "Planning and project department specialist",
    Contractor = "Contractor"
}